import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // For session cookies
});

// Add request interceptor for auth
api.interceptors.request.use((config) => {
  const accountKey = localStorage.getItem('accountKey');
  if (accountKey) {
    config.headers['X-Account-Key'] = accountKey;
  }
  return config;
});

// API Client methods
export const authApi = {
  login: (email: string, password: string) =>
    api.post('/users/sign_in', {
      user: { email, password },
    }),

  logout: () => api.delete('/users/sign_out'),

  register: (email: string, password: string, accountName: string) =>
    api.post('/users', {
      user: { email, password },
      account: { name: accountName },
    }),
};

export const servicesApi = {
  list: () => api.get('/api/v1/admin/services'),
  get: (id: string) => api.get(`/api/v1/admin/services/${id}`),
  create: (data: any) => api.post('/api/v1/admin/services', { service: data }),
  update: (id: string, data: any) => api.patch(`/api/v1/admin/services/${id}`, { service: data }),
  delete: (id: string) => api.delete(`/api/v1/admin/services/${id}`),
};

export const bookingsApi = {
  list: (params?: any) => api.get('/api/v1/admin/bookings', { params }),
  get: (id: string) => api.get(`/api/v1/admin/bookings/${id}`),
  create: (data: any) => api.post('/api/v1/admin/bookings', { booking: data }),
  update: (id: string, data: any) => api.patch(`/api/v1/admin/bookings/${id}`, { booking: data }),
  cancel: (id: string) => api.delete(`/api/v1/admin/bookings/${id}`),
};

export const clientsApi = {
  list: (params?: any) => api.get('/api/v1/admin/clients', { params }),
  get: (id: string) => api.get(`/api/v1/admin/clients/${id}`),
  create: (data: any) => api.post('/api/v1/admin/clients', { client: data }),
  update: (id: string, data: any) => api.patch(`/api/v1/admin/clients/${id}`, { client: data }),
  delete: (id: string) => api.delete(`/api/v1/admin/clients/${id}`),
};

export const publicApi = {
  getAvailability: (serviceId: string, date: string, staffProfileId?: string) =>
    api.post('/api/v1/public/availabilities', {
      service_id: serviceId,
      date,
      staff_profile_id: staffProfileId,
    }),

  createBooking: (data: any) =>
    api.post('/api/v1/public/bookings', { booking: data }),

  getBooking: (id: string) =>
    api.get(`/api/v1/public/bookings/${id}`),
};

export default api;
